module.exports = __webpack_public_path__ + "static/EUR-1-front-224fb72b67bc409ed1b316b5aa53c818.png";